import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useCurrentUser } from '../../../helpers/utils';
import { TENANT_NAME } from '../../../tenant/tenant-names';
import styles from './info-cards.module.scss';
import { InfoSectionCard, InfoSectionCardProps } from './info-section-card';
import { AppointmentsInfo } from './items/appointments-info';
import { TwoFactorInfo } from './items/two-factor-info';
import { Workflow } from './items/workflow';

export const InfoSection: FC = () => {
  const { formatMessage } = useIntl();

  const infoCards: InfoSectionCardProps[] = [
    {
      // route: "/workflow",
      title: formatMessage({ id: 'home.info.1' }),
      tag: formatMessage({ id: 'home.info.1.tag' }),
      subTitle: formatMessage({ id: 'home.info.1.subtitle' }),
      content: <Workflow />,
      imageSrc: '/info.jpg',
    },
    {
      route: '/facility-selection',
      tag: formatMessage({ id: 'appointments' }),
      title: formatMessage({ id: 'home.info.2' }),
      subTitle: formatMessage({ id: 'home.info.2.subtitle' }),
      content: <AppointmentsInfo />,
      imageSrc: '/appointments.jpg',
    },
    // {
    //   // route: "/documents",
    //   tag: formatMessage({ id: "home.info.3.tag" }),
    //   title: formatMessage({ id: "home.info.3" }),
    //   subTitle: formatMessage({ id: "home.info.3.subtitle" }),
    //   content: <Documents />,
    //   imageSrc: "/documents.jpg",
    // },
  ];

  const { currentUser } = useCurrentUser();
  if (currentUser?.id) {
    infoCards.push({
      // route: "/two-factor-auth",
      tag: formatMessage({ id: 'home.info.4.tag' }),
      title: formatMessage({ id: 'home.info.4' }),
      subTitle: formatMessage({ id: 'home.info.4.subtitle' }, { tenant: TENANT_NAME }),
      content: <TwoFactorInfo />,
      imageSrc: '/two-factor-auth.jpg',
    });
  }

  return (
    <div className={styles.infoSection}>
      {infoCards.map((infoCard, index) => (
        <InfoSectionCard
          index={index}
          key={index}
          {...infoCard}
          last={index === infoCards.length - 1}
        />
      ))}
    </div>
  );
};
